import type { Palette } from "@mui/material/styles";
import type { PaperworkDocTone } from "web_myplann/Profile/Constants/paperworkDocTypes";

type PaperworkToneColors = { bg: string; color: string };

export const getPaperworkToneColors = (
	palette: Palette,
	tone: PaperworkDocTone,
): PaperworkToneColors => {
	const colors: Record<PaperworkDocTone, PaperworkToneColors> = {
		blue: { bg: palette.blue[100], color: palette.blue[600] },
		orange: { bg: palette.orange[100], color: palette.orange[600] },
		green: { bg: palette.green[100], color: palette.green[600] },
		red: { bg: palette.red[100], color: palette.red[500] },
		gray: { bg: palette.grey[100], color: palette.grey[500] },
	};
	return colors[tone];
};
